import {
  Box,
  CircularProgress,
  IconButton,
  TextField,
  useTheme
} from "@mui/material";
import React, { FormEvent, RefObject, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "./AISupportChatMessageInput.styles";

interface AISupportChatMessageInputProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
  inputRef: RefObject<HTMLInputElement>;
}

const AISupportChatMessageInput = ({
  onSendMessage,
  disabled,
  isLoading,
  inputRef
}: AISupportChatMessageInputProps) => {
  const theme = useTheme();
  const [message, setMessage] = useState("");
  const { t } = useTranslation();

  const sendMessage = (e?: FormEvent<HTMLFormElement>) => {
    if (e) e.preventDefault();
    if (!message) return;
    setMessage("");
    onSendMessage(message);
    if (inputRef.current) inputRef.current.focus();
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && !e.altKey && !e.shiftKey) {
      sendMessage();
      e.preventDefault();
    }
  };

  return (
    <Container theme={ theme } gap={ "10px" }>
      <Box
        sx={ {
          flexGrow: 1
        } }
      >
        <form onSubmit={ sendMessage }>
          <TextField
            disabled={ disabled }
            inputRef={ inputRef }
            variant={ "standard" }
            placeholder={ t("ai_support_chat_input_ph") || "" }
            size={ "small" }
            value={ message }
            sx={ { padding: 0, width: "100%" } }
            multiline={ true }
            maxRows={ 2 }
            onKeyDown={ (event) => handleInputKeyDown(event) }
            onChange={ (event) => setMessage(event.target.value) }
            InputProps={ {
              disableUnderline: true,
              sx: {
                padding: 0
              }
            } }
          />
        </form>
      </Box>
      <IconButton
        onClick={ () => sendMessage() }
        disabled={ !message || disabled || isLoading }
      >
        { isLoading ? <CircularProgress size={ 24 } /> : (
          <svg style={ {
            display: "inline-block",
            stroke: theme.customColors.systemPrimary01,
            fill: "transparent",
            width: "1.5rem",
            height: "1.5rem"
          } }>
            <path
              d="M1.09339 18.8458C0.617785 20.2173 2.04887 21.4731 3.34761 20.824L20.1048 12.4479C21.2984 11.8514 21.2984 10.1486 20.1048 9.55206L3.34761 1.17604C2.04887 0.526866 0.617786 1.78271 1.09339 3.15423L3.63023 10.4698C3.74934 10.8132 3.74933 11.1868 3.63023 11.5302L2.99602 13.3591L2.67891 14.2736L2.36181 15.188"
              fill="transparent"></path>
          </svg>
        ) }
      </IconButton>
    </Container>
  );
};

export default AISupportChatMessageInput;
